<template lang="pug">
v-tooltip(v-if="silentTablets.length" bottom)
    template(v-slot:activator="{ on }")
        status-badge.mb-1(tone="critical" v-on="on")
            web2-icon.tablet-app-warning__icon(name="warning-triangle" :size="14")
            | {{ $t('tablets.order_warning', { battery: batteryText }) }}
    span {{ $t('tablets.order_warning_tooltip', { time: lastSignalText }) }}
</template>

<script>
import { mapGetters } from 'vuex'
import { getId } from '@/services/IdFromIri'
import { isTabletAppRunning } from '@/services/TabletAppStatus'
import StatusBadge from '@/components/elements/StatusBadge.vue'
import Web2Icon from '@/components/elements/Web2Icon.vue'

// Warns on a new (not yet approved) order when no tablet of its (non-Deliverect) restaurant
// runs the app, so an order that the restaurant will not see stands out in the list (tasks#158).
export default {
    components: {
        StatusBadge,
        Web2Icon,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        // reactive clock of the list: the app status ages without a Firebase update
        now: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters({ restaurantTablets: 'firebase/restaurantTablets' }),
        isActiveOrder() {
            // only an order still waiting for the restaurant's approval
            if (this.item.status !== 'new') return false
            if (!this.item.requiredDeliveryTime) return false
            return !this.$date(this.item.requiredDeliveryTime).isBefore(
                this.now.startOf('day')
            )
        },
        // the restaurant's tablets, latest heartbeat first; empty while any of them runs the app
        silentTablets() {
            if (!this.isActiveOrder) return []
            const tablets =
                this.restaurantTablets[getId(this.item.restaurant)] || []
            if (
                tablets.some((tablet) =>
                    isTabletAppRunning(tablet.timestamp, this.now)
                )
            )
                return []
            return [...tablets].sort(
                (a, b) => (b.timestamp || 0) - (a.timestamp || 0)
            )
        },
        lastSignalText() {
            const timestamp = this.silentTablets[0]?.timestamp
            return timestamp ? this.$date.unix(timestamp).fromNow() : '-'
        },
        batteryText() {
            const battery = this.silentTablets[0]?.battery
            return battery === undefined || battery === null ? '?' : battery
        },
    },
}
</script>

<style lang="scss">
.tablet-app-warning__icon {
    flex-shrink: 0;
    margin-right: 4px;
}
</style>
